import React from "react";

const Openinginvoiceservice = () => {
  return (
    <div className="p-1" style={{ background: "#F9F3F5" }}>
      <div className="heading ps-4">
        <h3>Opening Invoices Summary</h3>
      </div>
      <div className="row gap-2 ps-4">
         <div className="col-5 pb-3" >
           <div className="container " style={{ background: "#FFFFFF" }}>
            <div className="row ">
              <div className="col-md-12 m-0 p-0">
                <div className="border rounded p-3">
                  <div className="row mb-2">
                    <div className="col-4 fw-semibold">Company</div>
                    <div className="col-8 text-warning">
                      Lakshmi Narain Diamond (India) Pvt. Ltd.
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-4 fw-semibold">Invoice Type</div>
                    <div className="col-8 text-danger d-flex align-items-center gap-2">
                      Sales Invoice
                      <i className="fa-solid fa-arrow-up-right-from-square"></i>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-4 fw-semibold">Opening Invoices</div>
                    <div className="col-8">1</div>
                  </div>

                  <div className="row">
                    <div className="col-4 fw-semibold">Total Outstanding</div>
                    <div className="col-8 fw-semibold">₹ 100.00</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-5 pb-3 " >
           <div className="container " style={{ background: "#FFFFFF" }}>
            <div className="row">
              <div className="col-md-12 m-0 p-0">
                <div className="border rounded p-3">
                  <div className="row mb-2">
                    <div className="col-4 fw-semibold">Company</div>
                    <div className="col-8 text-warning">
                      Lakshmi Narain Diamond (India) Pvt. Ltd.
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-4 fw-semibold">Invoice Type</div>
                    <div className="col-8 text-danger d-flex align-items-center gap-2">
                      Sales Invoice
                      <i className="fa-solid fa-arrow-up-right-from-square"></i>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-4 fw-semibold">Opening Invoices</div>
                    <div className="col-8">1</div>
                  </div>

                  <div className="row">
                    <div className="col-4 fw-semibold">Total Outstanding</div>
                    <div className="col-8 fw-semibold">₹ 100.00</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Openinginvoiceservice;
